import React from 'react'
import { paydaslar } from "./paydaslar";
import { Button, Card, CardBody, CardSubtitle, CardText, CardTitle } from 'reactstrap';

export default function PaydasCard()
{
    return (
        <div class="container mt-3">
            <div class="row my-3 paydasCard">
                {
                    paydaslar.map((paydas, index) => (
                        <div class="col-md-3 text-center" key={index}>
                            {/* <h2>Ev Sahibi Üniversite</h2> */}
                            <Card>
                                <div class="paydasImg">
                                    <img
                                        width="150px"
                                        alt={paydas?.name}
                                        src={paydas?.imageUrl}
                                    />
                                </div>
                            </Card>
                        </div>
                    ))
                }
            </div>
        </div>
    )
}
